export default __webpack_public_path__ + "static/media/avatar_trex4.5c0995c3.mp3";